import Config from "./Config";
import { buildAppPageUrl } from "./ShopifyAdminLinkTools";

// The backend authenticates every request by the Shopify-signed query string this iframe
// was loaded with, and rejects it (401) once its `timestamp` is too old — i.e. a tab left
// open. Reloading the iframe itself would replay the same stale query, so a refresh has to
// go through Shopify Admin, which serves the app a newly signed one.

// A 401 on a query signed more recently than this is not expiry (uninstalled store, bad
// signature), and reloading would not fix it. Since a reload always yields a fresh
// timestamp, this also makes a reload loop impossible.
const MIN_STALE_AGE_SECONDS = 10 * 60;

let reloading = false;

export function isSignedQueryStale(search = window.location.search, nowMs = Date.now()) {
  const timestamp = Number(new URLSearchParams(search).get("timestamp"));
  if (!timestamp) return false;
  return nowMs / 1000 - timestamp > MIN_STALE_AGE_SECONDS;
}

/**
 * Reload the app through Shopify Admin, keeping the current page.
 * @returns {boolean} true if a reload was started (or is already under way)
 */
export function reloadAppWithFreshAuth(location = window.location) {
  if (reloading) return true;
  if (!isSignedQueryStale(location.search)) return false;

  const shop = new URLSearchParams(location.search).get("shop");
  if (!shop) return false;

  reloading = true;
  window.open(buildAppPageUrl(shop, Config.appName, location.pathname.replace(/^\/+/, "")), "_top");
  return true;
}
